// extracted by mini-css-extract-plugin
export default {"normal":"UTEK_m","italic":"GETg_B"};